import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { OverviewLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Overview = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* Slider */}
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> {t("Overview")} </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}

      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  ">
              <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {OverviewLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass"> {t("Overview")} </h3>
                  </div>
                  <div className="about-head1">
                    <h4 className="fontSizeClass ">{t("Overview_text_1")}</h4>
                  </div>
                  <div className="inner-title2 ">
                    <h3 className="fontSizeClass "> {t("The Mayor")} </h3>
                    <div className="col-lg-12 about-img2">
                      <p className="fontSizeClass">
                        {t(
                          "We believe that Kolkata has the potential to be one of the best cities of the world. We see Kolkata as a clean and attractive city of international repute in which all people have access to quality services"
                        )}
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="mayor-table mayor-table2a">
                <div className="row">
                  <table className="table table-bordered">
                    <thead>
                      <tr className="table-warning table-bor-2">
                        <th scope="col">{t("Sl-No")}</th>
                        <th scope="col">{t("Name")}</th>
                        <th scope="col">{t("Portfolios")} </th>
                        <th scope="col">{t("Office contact details")} </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">1</th>
                        <td> Firhad Hakim Hon'ble Mayor </td>
                        <td>
                          {t(
                            "Water Supply,Finance & Accounts, Grievances, Cultural Affairs, KEIIP, Licence"
                          )}
                          ,<br />
                          {t(
                            "Building,Central Stores,Assessment -Collection,TPDD and other"
                          )}
                          <br />
                          {t("departments not allotted to other members")}.
                        </td>
                        <td>
                          Office : 2286-1211 .<br /> Fax : 2286-1311/1011.
                          <br />
                          EPABX : 2286-1000, Extn. 2471 <br /> Int. Com.201
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="inner-title3">
                <h3 className="fontSizeClass">
                  {t("The Deputy Mayor and The Members, Mayor-In-Council")}
                </h3>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="mayor-table mayor-table2a my-2">
                <div className="row">
                  <div className="mayor-table">
                    <table className="table table-bordered">
                      <thead>
                        <tr className="table-warning table-bor-2">
                          <th className="bd-wid" scope="col">
                            {t("Sl-No")}
                          </th>
                          <th scope="col">{t("Name")}</th>
                          <th scope="col">{t("Portfolios")} </th>
                          <th scope="col">{t("Office Phone Nos")}. </th>
                          <th scope="col"> {t("e-mail")} </th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          {
                            name: "Sri Atin Ghosh Deputy Mayor",
                            portfolios:
                              "Health,Vector Control, Disinfectant Scheme, Archives,P&FA(F&SS),Central Medical Stores,MTM TB Hospital.",
                            officePhoneNos: [
                              "2286-1120 (Direct)",
                              "22861000 Extn. 2465",
                            ],
                            eMails: [
                              "mmic_hlth@kmcgov.in atinghosh503@gmail.com",
                              "ghosh.atin2009@yahoo.com",
                            ],
                          },
                          {
                            name: "Sri Debabrata Majumder MMIC",
                            portfolios: "SWM",
                            officePhoneNos: [
                              "2286-1116 (Direct)",
                              "22861000 Extn. 2466",
                            ],
                            eMails: [
                              "mmic_swm@kmcgov.in",
                              "dmswm_KMC@rediff.com",
                            ],
                          },
                          {
                            name: "Sri Debasish Kumar MMIC",
                            portfolios:
                              "Parks & Gardens, Sports,Advertisement, Parking & Hawker's Rehabilitation Schemes",
                            officePhoneNos: [
                              "2286-1114 (Direct)",
                              "22861000 Extn. 2499",
                            ],
                            eMails: ["mmic_pgs@kmcgov.in"],
                          },
                          {
                            name: "Sri Sandip Ranjan Bakshi MMIC",
                            portfolios: "Lighting & Electricity",
                            officePhoneNos: [
                              "2286-1119 (Direct)",
                              "22861000 Extn. 2463	",
                            ],
                            eMails: ["mmic_ltg@kmcgov.in"],
                          },
                          {
                            name: "Sri Jiban Saha MMIC",
                            portfolios:
                              "I & PR,EWS,Printing,IUM,Big-dia Tubewell",
                            officePhoneNos: [
                              "2286-1123(Direct)",
                              "22861000 Extn. 2568",
                            ],
                            eMails: ["mmic_ipr@kmcgov.in"],
                          },
                          {
                            name: "Sri Tarak Singh MMIC",
                            portfolios:
                              "Sewerage & Drainage Including( Drainage Pumping Station),SC(Mechanical)",
                            officePhoneNos: [
                              "2286-1115",
                              "22861000 Extn. 2467",
                            ],
                            eMails: ["mmic_sd@kmcgov.in"],
                          },
                          {
                            name: "Smt Mitali Banerjee MMIC",
                            portfolios:
                              "Swasthyasathi, BPL, NSAP, NFBS, NGR, Rupashri, Khadyasathi, NULM, Kanyashree",
                            officePhoneNos: [
                              "2286-1122(Direct)",
                              "22861000 Extn. 2468",
                            ],
                            eMails: ["mmic_bpl_nsap@kmcgov.in"],
                          },
                          {
                            name: "Sri Swapan Samaddar MMIC",
                            portfolios:
                              "Bustee Development, Environment & Heritage",
                            officePhoneNos: [
                              "2252-0280(Direct)",
                              "22861000 Extn. 2912",
                            ],
                            eMails: ["mmic_bustee@kmcgov.in"],
                          },
                          {
                            name: "Amiruddin(Bobby) MMIC",
                            portfolios: "Market",
                            officePhoneNos: [
                              "2286-1118 (Direct)",
                              "22861000 Extn. 2569",
                            ],
                            eMails: ["mmic_mkt@kmcgov.in"],
                          },
                          {
                            name: "Sri Sandipan Saha MMIC",
                            portfolios: "Education and IT",
                            officePhoneNos: [
                              "2252-0281",
                              "22861000 Extn. 2904",
                            ],
                            eMails: ["mmic_edn@kmcgov.in"],
                          },
                          {
                            name: "Sri Ashim Kumar Bose MMIC",
                            portfolios: "W.B.U.E.S",
                            officePhoneNos: ["..."],
                            eMails: ["..."],
                          },
                          {
                            name: "Sri Avijit Mukherjee MMIC",
                            portfolios: "Roads and Engineering",
                            officePhoneNos: [
                              "2252-0281",
                              "22861000 Extn. 2904",
                            ],
                            eMails: [
                              "mmic_re@kmcgov.in",
                              "avijitmukherjeekmc@gmail.com",
                            ],
                          },
                          {
                            name: "Sri Baiswanor Chatterjee MMIC",
                            portfolios: "Housing,Law,PPP and Personnel",
                            officePhoneNos: ["..."],
                            eMails: ["..."],
                          },
                        ].map((item, index) => (
                          <tr key={index}>
                            <th scope="row">{index + 1}</th>
                            <td>{item.name}</td>
                            <td>{item.portfolios}</td>
                            <td>
                              {item.officePhoneNos.map((no, i) => (
                                <p key={i}>{no}</p>
                              ))}
                            </td>
                            <td>
                              {item.eMails.map((mail, idx) => (
                                <p key={idx}>{mail}</p>
                              ))}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Overview;
